import { ThemeConfig, theme } from 'antd';

export const darkTheme: ThemeConfig = {
  algorithm: theme?.darkAlgorithm,
  token: {
    // colorPrimary: '#000', // Buttons, links, primary action elements (e.g. primary buttons, active links)

    colorBgBase: '#091320',
    // Background color for the main app layout — like the page background or main wrapper

    colorBgContainer: '#0B172B',
    // Background color for containers — Cards, Modals, Panels, Dropdowns, and other content boxes

    colorText: '#FFF',
    // Primary text color — used for main body text, headings, button text, etc. and  use in many other places ..global  search for find

    colorTextSecondary: '#94A3B8',
    // Secondary or muted text — subtitles, hints, descriptions, placeholder text, less important text
    // Matches our custom dark palette (slate-400)

    colorTextTertiary: '#94A3B8',
    // Tertiary text (Ant derives this as an even lighter shade by default)

    colorTextQuaternary: '#64748B',
    // Most muted text (icons, very subtle hints)

    colorTextDescription: '#94A3B8',
    // Description text (e.g., Card extra, Form Item help)

    colorTextPlaceholder: '#64748B',
    // Input/Select placeholder text

    colorBorder: '#2E3138',
    // Borders for inputs, selects, form controls, dividers, and other line separators

    colorBorderSecondary: '#2E3138',

    // Borders specifically for Cards, Panels, and some container borders

    colorSplit: '#2E3138',
    // for divider

    //custom bg color ====
    customBgColorOne: 'transparent',
    customBgColorForFilterBarOne: '#000',
    //custom border color
    customBorderColor: '#2E3138',
    customBorderColorTwo: '#2E3138',
    //custom text colo
    customColorTextTwo: '#FFF',

    //only for monitoring modal profile seciton======
    customBgColorForMonitoringCommonModal: 'transparent',
    customBgForKeystrockesModal: '#FFFFFF99',
    customBgColorForScreenShootCard: 'transparent',
    customSvgColorForScreenShootCard: '#FFF',
    customSvgColorForProfileDetailsCard: '#FFF',
    customBGForDeviceListCpuUsage: '#FFFFFF4D',
    customBgColorForMonthlyReportModalPP: 'transparent',
    customDashboardBarChartLabelColor: '#FFFFFFD9',
  },
  components: {
    Menu: {
      itemColor: '#fff', // normal text
      itemSelectedColor: '#1B73E8', // selected menu item text/icon color
      itemHoverColor: '#947DF0', // hover color
      itemSelectedBg: '#EFF8FF', // selected item background
      itemActiveBg: '#EFF8FF', // hover/active background
    },
    Layout: {
      siderBg: '#FFF',
      colorBgHeader: '#0B172B',
    },

    Typography: {
      // Matches our custom dark typography palette:
      //   Heading  → #FFFFFF (mirrors text-white)
      //   Body     → #CBD5E1 (mirrors text-[#CBD5E1] / slate-300)
      //   Muted    → #94A3B8 (mirrors text-[#94A3B8] / slate-400)
      colorTextHeading: '#FFFFFF',     // <Typography.Title> h1–h5
      colorText: '#CBD5E1',            // <Typography.Text> + <Typography.Paragraph> default
      colorTextDescription: '#94A3B8', // <Text type="secondary"> / description-style
    },
    Table: {
      headerBg: '#0F1E33',
      headerColor: '#FFFFFF',
      headerSplitColor: '#2E3138',
      headerSortActiveBg: '#142840',
      headerSortHoverBg: '#142840',
      bodySortBg: 'transparent',
      rowHoverBg: '#1E293B',
      rowSelectedBg: 'rgba(27, 115, 232, 0.15)',
      rowSelectedHoverBg: 'rgba(27, 115, 232, 0.20)',
      rowExpandedBg: 'rgba(27, 115, 232, 0.05)',
      borderColor: '#2E3138',
      footerBg: '#0F1E33',
      footerColor: '#FFFFFF',
      filterDropdownBg: '#0B172B',
      expandIconBg: '#0B172B',
    },
    Modal: {
      contentBg: '#091320', // Modal background
      headerBg: '#091320', // Modal header background
      titleColor: '#FFF', // Modal title text color
      footerBg: 'transparent', // Optional: Footer background
    },
    Tabs: {
      colorBorderSecondary: '#FFF',
      itemColor: '#FFFFFFD9',
    },
    Card: {
      colorBorderSecondary: 'transparent',
      boxShadow: 'none', // Optional: remove shadow if you want a cleaner look
    },
  },
};
